// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewTile_container__3Xq8M"};